import { format } from '@flex-packages/date';
import { TextNode } from 'lexical';

const formatText = (timestamp, presetName) => format({
  date: timestamp,
  presetName,
  locale: TimePresetNode.__locale,
  timeZone: TimePresetNode.__timeZone
});
const _TimePresetNode = class _TimePresetNode extends TextNode {
  static getType() {
    return "time-preset";
  }
  static clone(node) {
    return new _TimePresetNode(
      formatText(node.__timestamp, node.__presetName),
      node.__timestamp,
      node.__presetName,
      node.__key
    );
  }
  static setSystemValue(timeZone, locale) {
    this.__timeZone = timeZone;
    this.__locale = locale;
  }
  static importJSON(serializedNode) {
    return new _TimePresetNode(
      formatText(serializedNode.timestamp, serializedNode.presetName),
      serializedNode.timestamp,
      serializedNode.presetName
    ).updateFromJSON(serializedNode);
  }
  constructor(text = "", timestamp, presetName, key) {
    super(text, key);
    this.__text = formatText(timestamp, presetName);
    this.__timestamp = timestamp;
    this.__presetName = presetName;
  }
  updateFromJSON(serializedNode) {
    const self = super.updateFromJSON(serializedNode);
    self.__text = formatText(
      serializedNode.timestamp,
      serializedNode.presetName
    );
    self.__timestamp = serializedNode.timestamp;
    self.__presetName = serializedNode.presetName;
    return self;
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: this.getType(),
      text: this.__text,
      timestamp: this.__timestamp,
      presetName: this.__presetName
    };
  }
  createDOM(config, _editor) {
    const dom = super.createDOM(config);
    dom.textContent = formatText(this.__timestamp, this.__presetName);
    return dom;
  }
  updateDOM(prevNode, dom, config) {
    if (super.updateDOM(prevNode, dom, config)) {
      return true;
    }
    if (prevNode.__presetName !== this.__presetName || prevNode.__timestamp !== this.__timestamp) {
      dom.textContent = formatText(this.__timestamp, this.__presetName);
      return true;
    }
    return false;
  }
};
/**
 * 사용처에서 dynamic하게 넣어주길 기대하는 값인데 lexical에서 그러한 창구를 제공하지 않는다.
 * static method를 사용하는 방식은 위험할 수 있지만 locale/timezone 값이 하나의 클라이언트에서 자주 변경되는 값은 아니어서 이 방식을 선택한다
 *
 * https://flex-cv82520.slack.com/archives/CS05YNN9H/p1754983650982479
 */
_TimePresetNode.__timeZone = "Asia/Seoul";
_TimePresetNode.__locale = "ko";
let TimePresetNode = _TimePresetNode;

export { TimePresetNode };
//# sourceMappingURL=TimePresetNode.mjs.map
